module.exports = __webpack_public_path__ + "static/AZ-d9434cbcc36242f3a57f78b0263fcdb1.svg";